module.exports = __webpack_public_path__ + "img/visa.95d0f046.svg";